import React from 'react';
import { withTranslation } from 'react-i18next';

import ActionButton from 'jbc-front/components/ActionButton';
import { Edit, Strage, MinusCircle, Task, Revert } from 'jbc-front/components/icons';

import { BONUS_DETAIL_PDF } from 'src/constants/EndpointUrls';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';

import { isModeEdit, isModeView } from './EmployeeBonusForm';
import styles from './ActionButtonsSection.scss';

class ActionButtonsSection extends React.Component {
  state = {
    isPdfPreview: false
  };

  showPreview = () => {
    this.setState({ ...this.state, isPdfPreview: true });
  };
  hidePreview = () => {
    this.setState({ ...this.state, isPdfPreview: false });
  };

  render() {
    const {
      employeeBonusId,
      mode,
      submit,
      reset,
      changeFormMode,
      rollbackInputForm,
      clientBonusConfirmed,
      submitting
    } = this.props;

    return (
      <div className={styles.buttons}>
        <div className={styles.buttonsLeft}>
          {isModeEdit(mode) && (
            <div className={styles.buttonsLeft}>
              <ActionButton onClick={submit} icon={<Strage size={14} />} disabled={submitting}>
                {this.props.t('features.EmployeeBonus.components.ActionButtonSection.save', { framework: "react-i18next" })}
              </ActionButton>
              <ActionButton
                onClick={() => {
                  reset();
                  changeFormMode('view');
                }}
                icon={<MinusCircle size={14} />}
              >
                {this.props.t('features.EmployeeBonus.components.ActionButtonSection.cancel', { framework: "react-i18next" })}
              </ActionButton>
            </div>
          )}
          {isModeView(mode) && (
            <ActionButton
              onClick={() => changeFormMode('edit')}
              icon={<Edit size={14} />}
              disabled={clientBonusConfirmed}
            >
              {this.props.t('features.EmployeeBonus.components.ActionButtonSection.edit', { framework: "react-i18next" })}
            </ActionButton>
          )}
        </div>
        <div className={styles.buttonsRight}>
          {isModeEdit(mode) && (
            <ActionButton
              icon={<Revert size={16} />}
              onClick={() => {
                rollbackInputForm(employeeBonusId);
                changeFormMode('view');
              }}
            >
              {this.props.t('features.EmployeeBonus.components.ActionButtonSection.back_to_before_manual_input', { framework: "react-i18next" })}
            </ActionButton>
          )}
          <ActionButton primary icon={<Task size={15} />} onClick={this.showPreview} disabled={!clientBonusConfirmed}>
            {this.props.t('features.EmployeeBonus.ShowBonusFbDataPage.PDF_export', { framework: "react-i18next" })}
          </ActionButton>
          <PreviewPdfModalContainer
            header={this.props.t('features.EmployeeBonus.components.UnconfirmBonusModal.bonus_statement', { framework: "react-i18next" })}
            isOpen={this.state.isPdfPreview}
            hideModal={this.hidePreview}
            url={`${BONUS_DETAIL_PDF}?id=${employeeBonusId}`}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation('translation')(ActionButtonsSection);
